import React, { useState, useEffect, useCallback } from 'react';
import debounce from "lodash.debounce";
import { InputFieldsWrapper } from '.././PTPlusStyled'
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import TextInput from 'web/components/form-elements/TextInput';
import PhoneNumber from 'web/components/form-elements/PhoneNumber';
import { storeAdminDetails, logoutAdmin} from 'redux/actions/admin';
import states from 'states-us';
import NumberInput from 'web/components/form-elements/NumberInput';
import { adminRegisterUserApi, checkIsValidEmail, checkIsZipCode } from 'redux/actions/adminPtPlus/index';

import AlertModal from 'web/components/AlertModal';

function BasicInfo(pageProps) {
    const dispatch = useDispatch();
    let history = useHistory()
    const [alertModal, setAlertModal] = useState(false);
    const [alertModalContent, setAlertModalContent] = useState('');
    const [saveDisableState, setSaveDisableState] = useState(true)
    const [isValidEmail, setIsValidEmail] = useState(true)
    const [isValidZip, setIsValidZip] = useState(true)

    const territoryStates = states.filter((x) => x.contiguous);
    let stateArr = []
    for (let i = 0; i < territoryStates.length; i++) {
        if (territoryStates[i].name !== 'District Of Columbia') {
            let obj = {
                value: territoryStates[i].name,
                label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
                isoCode: territoryStates[i].abbreviation
            }
            stateArr.push(obj)
        }
    }

    useEffect(() => {
        let fieldValues = pageProps.formikProps.values
        if (isValidEmail && isValidZip && fieldValues.userName.trim() !== '' && fieldValues.phoneNumber.trim() !== '' && fieldValues.businessName.trim() !== '' && fieldValues.email.trim() !== '' &&
            fieldValues.address.trim() !== '' && fieldValues.city.trim() !== '' && fieldValues.state.trim() !== '' && fieldValues.zip.trim() !== '' && parseInt(fieldValues.zip) > 0) {
            setSaveDisableState(false)
        } else setSaveDisableState(true)
    }, [pageProps.formikProps, isValidEmail, isValidZip])

    const adminRegisterUserFunc = async () => {
        let fieldValues = pageProps.formikProps.values
        let response = '';
        let data = {
            id: pageProps.tempRegId ? pageProps.tempRegId : null,
            emailAddress: fieldValues.email?.trim(),
            contactNumber: fieldValues.phoneNumber?.trim(),
            customerName: fieldValues.userName?.trim(),
            locationName: fieldValues.businessName?.trim(),
            notes: fieldValues.notes?.trim(),
            locationAddress: {
                name: fieldValues.businessName?.trim(),
                contactNumber: fieldValues.phoneNumber?.trim(),
                locationName: fieldValues.businessName?.trim(),
                street: fieldValues.address?.trim(),
                city: fieldValues.city?.trim(),
                state: fieldValues.state?.trim(),
                zipCode: fieldValues.zip?.trim(),
            },
            registrationStatus: "DRAFT"
        }
        const token = localStorage.getItem('token')
        response = await dispatch(adminRegisterUserApi(data, token))
        if (response.success) {
            pageProps.tempRegSetFunc(response.data.msg)
            setAlertModalContent('Details saved successfully.')
            setAlertModal(!alertModal)
            setTimeout(() => {
                pageProps.nextStepCallBack('forward', 'step1')
                setAlertModal(false)
            }, 1000)
        } else {
            if (response.statusCode === 401) {
                adminLogout()
            } else {
                setAlertModalContent(response.message)
                setAlertModal(!alertModal)
            }
        }
    }

    const adminLogout = () => {
        dispatch(storeAdminDetails([], {}))
        dispatch(logoutAdmin())
        localStorage.removeItem('adminRolesData')
        localStorage.removeItem('adminName')
        localStorage.removeItem('adminEmail')
        localStorage.removeItem('token')
        history.push('./sign-in')
        window.location.reload(false);
    }

    const changeHandler = (value) => {
        let email = value?.trim()
        handleDebounceEmailCheck(email);
    }
    const handleDebounceEmailCheck = useCallback(debounce((email) => emailCheckFuncCall(email), 500), []);
    const emailCheckFuncCall = async (value) => {
        const token = localStorage.getItem('token')
        let response = '';
        response = await dispatch(checkIsValidEmail(value, token))
        if (response.success) {
            setIsValidEmail(true)
        } else {
            if (response?.data?.error?.message === 'Email Address already exists.') {
                setIsValidEmail(false)
            } else if (response.statusCode === 401) {
                adminLogout()
            } else {
                setAlertModalContent(response.message || 'Something went wrong, please try again.')
                setAlertModal(!alertModal)
            }
        }
    }

    const zipChangeHandler = async (value) => {
        const token = localStorage.getItem('token')
        let response = '';
        if (value.length === 5) {
            response = await dispatch(checkIsZipCode(value, token))
            if (response.success) {
                setIsValidZip(true)
                pageProps.setFieldValue('state', response.data?.state)
                pageProps.setFieldValue('city', response.data?.city)
            } else {
                if (response?.data?.error?.message === 'Invalid Zip Code.') {
                    setIsValidZip(false)
                    pageProps.setFieldValue('state', '')
                    pageProps.setFieldValue('city', '')
                } else if (response.statusCode === 401) {
                    adminLogout()
                } else {
                    setAlertModalContent(response.message || 'Something went wrong, please try again.')
                    setAlertModal(!alertModal)
                }
            }
        } else {
            setIsValidZip(true)
            pageProps.setFieldValue('state', '')
            pageProps.setFieldValue('city', '')
        }
    }

    return (
        <>
            <div>
                <div className='section-header'>
                    <img src={RightArrow} alt="RightArrow" className="right-arrow" />
                    <p>Company Profile<span className='star'>&#42;</span></p>
                </div>

                <div style={{ margin: '10px 0 0 80px' }}>
                    <InputFieldsWrapper>
                        <div className="row">
                            <div className="col-md-6">
                                <TextInput name='businessName' inputType='ptPlusAdminRegisterLocationName' placeholder={`Company Name*`} />
                            </div>
                            <div className={!isValidEmail ? 'col-md-6 error-styling-input' : 'col-md-6'}>
                                <TextInput name="email" placeholder={`Email*`} changeHandler={changeHandler} />
                                {!isValidEmail && <p style={{ marginTop: '-7px' }}>Email already exists.</p>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <TextInput name='address' placeholder={`Address*`} />
                            </div>
                            <div className="col-md-6">
                                <TextInput name="city" placeholder={`City*`} inputType='text' />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <TextInput name="state" placeholder={`State*`} disabled inputType='text' />
                            </div>
                            <div className={!isValidZip ? 'col-md-6 error-styling-input' : 'col-md-6'}>
                                <NumberInput name="zip" placeholder={`Zip*`} maxLength={5} callBackFlag={true} callBackFun={zipChangeHandler} />
                                {!isValidZip && <p style={{ marginTop: '-7px' }}>Zipcode is invalid.</p>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <TextInput name='userName' placeholder={`Contact Full Name*`} inputType='text' />
                            </div>
                            <div className="col-md-6">
                                <PhoneNumber name="phoneNumber" placeholder={`Company Phone Number*`} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <TextInput name='notes' placeholder={`Notes`} maxLength={200} />
                            </div>
                        </div>
                    </InputFieldsWrapper>
                </div>
            </div>

            <div className='button-section'>
                <div style={{ marginLeft: '80px' }}>
                    <button className={saveDisableState ? 'save-button disabled' : 'save-button'} disabled={saveDisableState} onClick={() => adminRegisterUserFunc()}>Save</button>
                    <button className='skip-button' onClick={() => pageProps.skipButtonCall()}>Skip</button>
                </div>
                <div style={{ display: 'flex' }}>
                    <div className='round-wrapper left disabled'><p></p></div>
                    <div className={saveDisableState ? 'round-wrapper right disabled' : 'round-wrapper right'} onClick={() => !saveDisableState && adminRegisterUserFunc()}><p></p></div>
                </div>
            </div>

            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                title=''
                content={alertModalContent}
            />
        </>
    )

}

export default BasicInfo